import { http } from './http';
import type { TaskListItem, TaskDetail, DeliveryType } from '@/types';

function urlType(type: DeliveryType): string {
  return type === 'FOOD' ? 'food' : 'cloth';
}

export const tasksApi = {
  getTasks() {
    return http.get<{ tasks: TaskListItem[] }>('/rider/tasks');
  },
  getTaskDetail(type: DeliveryType, taskId: string) {
    return http.get<{ task: TaskDetail }>(`/rider/tasks/${urlType(type)}/${taskId}`);
  },
  acceptTask(type: DeliveryType, taskId: string) {
    return http.post(`/rider/tasks/${urlType(type)}/${taskId}/accept`);
  },
  rejectTask(type: DeliveryType, taskId: string, reason: string) {
    return http.post(`/rider/tasks/${urlType(type)}/${taskId}/reject`, { reason });
  },
  pickupTask(type: DeliveryType, taskId: string) {
    return http.post(`/rider/tasks/${urlType(type)}/${taskId}/pickup`);
  },
  deliverTask(type: DeliveryType, taskId: string, otp: string) {
    return http.post(`/rider/tasks/${urlType(type)}/${taskId}/deliver`, { otp });
  },
};
